/**
 * Custom-roles resource — named permission bundles assignable to agents
 * (old-cockpit "User Management → Roles"). Requires the `roles.manage`
 * permission (owners/admins always hold it).
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { CustomRole, CustomRoleInput, PermissionInfo } from '../../types';

export class RolesResource {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<{ items: CustomRole[] }> {
    return this.http.get(endpoints.roles.list());
  }

  create(input: CustomRoleInput): Promise<CustomRole> {
    return this.http.post(endpoints.roles.create(), input);
  }

  update(roleId: string, patch: Partial<CustomRoleInput>): Promise<CustomRole> {
    return this.http.patch(endpoints.roles.detail(roleId), patch);
  }

  remove(roleId: string): Promise<{ ok: boolean }> {
    return this.http.delete(endpoints.roles.detail(roleId));
  }

  /** The assignable permission catalog (key + display group/label). */
  permissions(): Promise<{ items: PermissionInfo[] }> {
    return this.http.get(endpoints.roles.permissions());
  }
}
